import { Link } from "react-router-dom";
import compligaurdLogo from "@/assets/compligaurd-logo.webp";

const Footer = () => {
  return (
    <footer className="py-12 sm:py-16 border-t border-border" style={{ backgroundColor: 'hsl(209 65% 12%)' }}>
      <div className="container max-w-6xl px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 sm:gap-10 items-start">
          {/* Wordmark */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={compligaurdLogo} alt="CompliGUARD — Compliance infrastructure for Australian health brands" className="h-6 w-6" />
              <span className="text-white text-lg font-bold tracking-wide">
                Compli<span className="gold-text">GUARD</span>
              </span>
            </div>
            <p className="text-[hsl(210_30%_90%)] text-xs leading-relaxed">
              Compliance infrastructure for Australian health brands & practitioners.
            </p>
          </div>

          {/* Product */}
          <div className="flex flex-col gap-2.5">
            <span className="text-[hsl(211_22%_57%)] text-[10px] uppercase tracking-widest mb-1">Product</span>
            <Link to="/vds-brands" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">For VDS Brands</Link>
            <Link to="/practitioners" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">For Practitioners</Link>
            <Link to="/pricing" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Pricing</Link>
            <Link to="/signup" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Sign Up</Link>
            <Link to="/login" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Login</Link>
          </div>

          {/* Company */}
          <div className="flex flex-col gap-2.5">
            <span className="text-[hsl(211_22%_57%)] text-[10px] uppercase tracking-widest mb-1">Company</span>
            <Link to="/about" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">About Us</Link>
            <Link to="/speaking" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Speaking</Link>
            <Link to="/help" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Help & FAQ</Link>
            <Link to="/contact" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Contact</Link>
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-2.5">
            <span className="text-[hsl(211_22%_57%)] text-[10px] uppercase tracking-widest mb-1">Compliance Guides</span>
            <Link to="/guides/supplement-vds-brand-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Supplement & VDS</Link>
            <Link to="/guides/online-pharmacy-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Online Pharmacy</Link>
            <Link to="/guides/telehealth-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Telehealth</Link>
            <Link to="/guides/medical-device-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Medical Devices</Link>
            <Link to="/guides/aesthetic-clinic-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Aesthetic Clinics</Link>
            <Link to="/guides/naturopath-allied-health-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Naturopaths & Allied Health</Link>
            <Link to="/guides/dental-practice-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Dental Practices</Link>
            <Link to="/guides/health-food-functional-beverage-advertising-compliance-australia-2025" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors">Health Food & Beverages</Link>
          </div>

          {/* Legal */}
          <div className="flex flex-col gap-2.5">
            <span className="text-[hsl(211_22%_57%)] text-[10px] uppercase tracking-widest mb-1">Legal</span>
            <Link to="/terms" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Terms & Conditions</Link>
            <Link to="/privacy" className="text-[hsl(210_30%_90%)] text-sm hover:text-primary transition-colors duration-200">Privacy Policy</Link>
            <Link to="/dpa" className="text-text-body text-sm hover:text-primary transition-colors duration-200">Data Processing Addendum</Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 sm:mt-14 pt-6 border-t border-primary/30">
          <p className="text-[hsl(210_30%_90%)] text-xs text-center opacity-80">
            © {new Date().getFullYear()} CompliGUARD Pty. Ltd. ACN 697 118 228
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
